import { useMutation } from "react-query";
import http from "infra/http";
import { AxiosError } from "axios";

function useExcluirEquipamento() {
  return useMutation<
    void,
    AxiosError,
    string
  >(
    async (id: string) => {
      await http.delete(`/v1/equipamento/${id}`);
    },
    { retry: false }
  );
}

export default useExcluirEquipamento;
